import { useQuery } from 'react-query';

import { AuditTrailGetRequestDto } from '../../../../../backend/src/auditTrail/dto/auditTrail-get.request.dto';
import { AuditTrailGetResponseDto } from '../../../../../backend/src/auditTrail/dto/auditTrail-get.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

const useGetAuditTrail = ({ enabled, data }: { enabled: boolean; data: AuditTrailGetRequestDto }) => {
  const { getFetchConfig } = useGetFetchConfig();

  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data,
  });

  return useQuery<AuditTrailGetResponseDto>(
    [
      QueryEntity.AuditTrail,
      data.startDate,
      data.endDate,
      data.matterId,
      data.userId,
      data.organisationId,
      data.auditEventType,
      data.page,
      data.pageSize,
      data.searchQuery,
      data.sortBy,
      data.sortDir,
    ],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/auditTrail`, {
        ...fetchConfigPOST,
      });
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    },
    { refetchOnWindowFocus: false, enabled },
  );
};

export default useGetAuditTrail;
